<template>
  <b-badge
    class="state-badge"
    pill
    v-text="label"
    :variant="variant"
  />
</template>

<script>
import { coolingMaintenanceStateTypes } from '@/domain/enums/installation/engineering/coolingMaintenance/coolingMaintenanceStateTypes';

export default {
  name: 'SwitchBadge',
  props: {
    value: String,
  },
  computed: {
    variant() {
      switch (this.value) {
        case coolingMaintenanceStateTypes.ON:
          return 'active';
        case coolingMaintenanceStateTypes.OFF:
          return 'inactive';
        default:
          return 'indeterminate';
      }
    },
    label() {
      switch (this.value) {
        case coolingMaintenanceStateTypes.ON:
          return 'ON';
        case coolingMaintenanceStateTypes.OFF:
          return 'OFF';
        default:
          return '-';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/vendor/customizations/custom-bootstrap-vars.sass"
@import ~bootstrap/scss/mixins/_badge
@import ~bootstrap/scss/mixins/_hover
@import "src/styles/components/badge-default-colors.sass"

.state-badge
  padding: 6px 15px
  &.badge-active
    @include badge-variant($status-active)
    color: #fff
  &.badge-inactive
    @include badge-variant($status-disabled)
    color: #fff

@media print
  .badge
    border: none
</style>
